import React from 'react';

import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { IPoll } from '@vimeo/live-core/types/interaction_tools';

import { createInteractionDomName } from '../../../../../libs/shared/utils/dom/identifying';
import { PollOptionVotesBar } from '../../../polls/poll_item/PollOptionVotesBar';

interface IPollResultsProps extends IBaseDomElementProps {
  poll: IPoll;
}

export function PollResults({
  id = createInteractionDomName('poll-results'),
  poll,
}: IPollResultsProps) {
  const totalVotesCount: number = poll.options.reduce((acc, option) => acc + option.votesCount, 0);

  return (
    <>
      {poll.options.map((opt, index) => (
        <PollOptionVotesBar
          id={createInteractionDomName(id, 'option', index)}
          key={opt.id}
          option={opt}
          state={poll.state}
          totalCount={totalVotesCount}
          isBold={true}
        />
      ))}
    </>
  );
}
